<div id="main-header" class="header" [class.hidden]="!loggedIn">
    <alii-web-navigation></alii-web-navigation>
</div>
